import React from 'react';
import SEO from '../components/SEO';
import CustomHeader from '../components/CustomHeader';

function DownloadPage() {
  return (
   <div className="subcustom-header-container">

      <SEO 
        title="제스트정보기술"
        description="오픈소스, IT인프라 소프트웨어, 성능모니터링 전문기업"
      />
      <CustomHeader />
      <header className="subcustom-header">
        <div className="hero-title-area">
          <div className="hero-subtitle">다운로드</div>
          <h2 className="hero-title">기술지원 프로그램</h2>
        </div>
      </header>
	  
    <div className="page-container">
      <main className="product-detail-page">
        <div className="product-detail-container">

          {/* 다운로드 목록 */}
          <section className="solution-section">
            <h2 className="section-title">기술지원 프로그램</h2>

            <div
              className="info-grid"
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '32px',
                alignItems: 'stretch',
                marginTop: '18px'
              }}
            >
              {/* 다운로드 항목 1 */}
              <div
                style={{
                  flex: '1',
                  minWidth: '260px',
                  padding: '28px',
                  borderRadius: '18px',
                  background: '#fff',
                  boxShadow: '0 4px 24px rgba(0,0,0,0.10)'
                }}
              >
                <h3 style={{ fontSize: '1.35rem', color: '#1a365d', marginBottom: '14px' }}>
                  TeamViewer
                </h3>

                <p style={{ fontSize: '1.05rem', color: '#333', lineHeight: 1.7, marginBottom: '24px' }}>
                  기술지원 담당자가 원격으로 고객 PC에 접속하여 문제를 확인하고
                  지원할 수 있는 프로그램입니다.
                </p>

                <a
                  href="https://download.teamviewer.com/download/TeamViewerQS_x64.exe"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    background: '#1a365d',
                    color: '#fff',
                    textDecoration: 'none',
                    fontWeight: 'bold'
                  }}
                >
                  다운로드
                </a>
              </div>

              {/* 다운로드 항목 2 */}
              <div
                style={{
                  flex: '1',
                  minWidth: '260px',
                  padding: '28px',
                  borderRadius: '18px',
                  background: '#fff',
                  boxShadow: '0 4px 24px rgba(0,0,0,0.10)'
                }}
              >
                <h3 style={{ fontSize: '1.35rem', color: '#1a365d', marginBottom: '14px' }}>
                  Seetrol
                </h3>

                <p style={{ fontSize: '1.05rem', color: '#333', lineHeight: 1.7, marginBottom: '24px' }}>
                  기술지원 담당자가 원격으로 고객 PC에 접속하여 문제를 확인하고
                  지원할 수 있는 프로그램입니다.
                </p>

                <a
                  href="https://xest.kr/download/xest.kr-0.exe"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    background: '#667eea',
                    color: '#fff',
                    textDecoration: 'none',
                    fontWeight: 'bold'
                  }}
                >
                  다운로드
                </a>
              </div>
            </div>
          </section>

        </div>
      </main>
    </div>
   </div>
  );
}

export default DownloadPage;